module.exports = __webpack_public_path__ + "img/schedules.82c37fe2.svg";